export namespace DEPOSIT_TYPE {
    export const FLAT_DEPOSIT = "flat"
    export const PERCENTAGE_DEPOSIT = "percentage"
}
export type DEPOSIT_TYPE = typeof DEPOSIT_TYPE[keyof typeof DEPOSIT_TYPE]


// WEBPACK FOOTER //
// ./src/state/pricing/DepositTypes.ts